import {
  GET_CUSTOM_LOCATIONS_REQUEST,
  GET_CUSTOM_LOCATIONS_SUCCESS,
  GET_CUSTOM_LOCATIONS_FAILURE,
  GET_CUSTOM_LOCATIONS_CLEAR,
  CREATE_CUSTOM_LOCATION_REQUEST,
  CREATE_CUSTOM_LOCATION_SUCCESS,
  CREATE_CUSTOM_LOCATION_FAILURE,
  CREATE_CUSTOM_LOCATION_CLEAR,
  UPDATE_CUSTOM_LOCATION_REQUEST,
  UPDATE_CUSTOM_LOCATION_SUCCESS,
  UPDATE_CUSTOM_LOCATION_FAILURE,
  UPDATE_CUSTOM_LOCATION_CLEAR,
  DELETE_CUSTOM_LOCATION_REQUEST,
  DELETE_CUSTOM_LOCATION_SUCCESS,
  DELETE_CUSTOM_LOCATION_FAILURE,
  DELETE_CUSTOM_LOCATION_CLEAR,
} from '../actions/types';

const initialState = {
  customLocations: [],
  loading: false,
  error: null,
  getStatus: null,
  createStatus: null,
  updateStatus: null,
  deleteStatus: null
};

export default function customLocationsReducer(state = initialState, action) {
  switch (action.type) {
    // GET custom locations
    case GET_CUSTOM_LOCATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        getStatus: 'pending'
      };
    case GET_CUSTOM_LOCATIONS_SUCCESS:
      return {
        ...state,
        customLocations: action.payload.data,
        loading: false,
        error: null,
        getStatus: 'success'
      };
    case GET_CUSTOM_LOCATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        getStatus: 'failure'
      };
    case GET_CUSTOM_LOCATIONS_CLEAR:
      return {
        ...state,
        error: null,
        getStatus: null
      };

    // CREATE custom location
    case CREATE_CUSTOM_LOCATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        createStatus: 'pending'
      };
    case CREATE_CUSTOM_LOCATION_SUCCESS:
      return {
        ...state,
        customLocations: [...state.customLocations, action.payload],
        loading: false,
        error: null,
        createStatus: 'success'
      };
    case CREATE_CUSTOM_LOCATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        createStatus: 'failure'
      };
    case CREATE_CUSTOM_LOCATION_CLEAR:
      return {
        ...state,
        error: null,
        createStatus: null
      };

    // UPDATE custom location
    case UPDATE_CUSTOM_LOCATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        updateStatus: 'pending'
      };
    case UPDATE_CUSTOM_LOCATION_SUCCESS:
      return {
        ...state,
        customLocations: state.customLocations.map(location => 
          location.id === action.payload.id ? action.payload : location
        ),
        loading: false,
        error: null,
        updateStatus: 'success'
      };
    case UPDATE_CUSTOM_LOCATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        updateStatus: 'failure'
      };
    case UPDATE_CUSTOM_LOCATION_CLEAR:
      return {
        ...state,
        error: null,
        updateStatus: null
      };

    // DELETE custom location
    case DELETE_CUSTOM_LOCATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        deleteStatus: 'pending'
      };
    case DELETE_CUSTOM_LOCATION_SUCCESS:
      return {
        ...state,
        customLocations: state.customLocations.filter(location => 
          location.id !== action.payload
        ),
        loading: false,
        error: null,
        deleteStatus: 'success'
      };
    case DELETE_CUSTOM_LOCATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        deleteStatus: 'failure'
      };
    case DELETE_CUSTOM_LOCATION_CLEAR:
      return {
        ...state,
        error: null,
        deleteStatus: null
      };

    default:
      return state;
  }
}
